import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0db161c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden" }
const _hoisted_3 = { class: "w-11/12 mx-auto px-4 sm:px-8" }
const _hoisted_4 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-overlay absolute w-full h-full bg-gray-900 opacity-50" }, null, -1))
const _hoisted_6 = { class: "relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "text-gray-400 dark:text-gray-500 w-11 h-11 mb-3.5 mx-auto",
  "aria-hidden": "true",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
    "clip-rule": "evenodd"
  })
], -1))
const _hoisted_10 = { class: "mb-4 text-gray-500 dark:text-gray-300" }
const _hoisted_11 = { class: "flex justify-center items-center space-x-4" }
const _hoisted_12 = {
  key: 1,
  class: "py-8"
}
const _hoisted_13 = { class: "w-full mx-auto grid grid-cols-1 lg:grid-cols-3 justify-between gap-2" }
const _hoisted_14 = { class: "flex gap-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.4294 0H12.5583C12.6615 0.0234399 12.7443 0.0500052 12.806 0.0812585C16.7791 2.06818 20.7522 4.05355 24.7268 6.03657C24.8331 6.0897 24.9112 6.18033 24.9596 6.30769C24.9893 6.38426 25.0042 6.49755 25.0034 6.64679C25.0003 8.39072 24.9995 10.1354 25.0018 11.8794C25.0018 12.5349 24.0634 12.7365 23.8142 12.131C23.7689 12.0208 23.7462 11.8301 23.747 11.5582C23.7494 10.2417 23.7501 8.9228 23.7478 7.60157C23.7478 7.58907 23.7353 7.58204 23.7243 7.58673C20.1248 9.3877 16.5228 11.1894 12.9193 12.9928C12.649 13.1279 12.4685 13.1912 12.2052 13.0592C10.4597 12.1794 8.71106 11.3035 6.9601 10.4308C6.94057 10.4206 6.93119 10.4269 6.93119 10.448C6.9265 11.6379 6.92572 12.8271 6.92963 14.0171C6.93119 14.5242 6.43973 14.8195 5.99047 14.5875C5.74826 14.4624 5.68184 14.2124 5.68106 13.9327C5.68028 12.5583 5.68028 11.1879 5.68106 9.82212C5.68106 9.79946 5.6709 9.78305 5.65059 9.77289L1.27591 7.5836C1.26341 7.57813 1.24935 7.58673 1.24935 7.60079V17.7229C1.24935 17.7433 1.25872 17.7589 1.2767 17.7698C4.88176 19.7732 8.48682 21.7773 12.0911 23.7806C12.9201 24.2408 12.331 25.3472 11.4723 24.869C7.75471 22.8 4.03558 20.7326 0.316439 18.666C0.146109 18.5715 0.0406292 18.4168 0 18.2035V6.40848C0.130482 6.04594 0.352381 6.00219 0.66335 5.84748C4.51297 3.91994 8.36337 1.99318 12.2138 0.0679758C12.2661 0.0414106 12.338 0.0195333 12.4302 0M2.06115 6.54521C2.04631 6.55224 2.04631 6.57334 2.06115 6.58037L6.29519 8.69934C6.30066 8.70247 6.30769 8.70247 6.31238 8.69934L16.7424 3.48083C16.7572 3.4738 16.7572 3.4527 16.7424 3.44567L12.5052 1.32904C12.4997 1.32592 12.4927 1.32592 12.488 1.32904L2.06115 6.54521ZM7.73674 9.38613C7.72346 9.39317 7.72346 9.4127 7.73674 9.41973L12.4943 11.8012C12.4997 11.8036 12.5052 11.8036 12.5107 11.8012L22.9485 6.58037C22.9618 6.57334 22.9618 6.55381 22.9485 6.54678L18.1847 4.16606C18.1792 4.16371 18.1738 4.16371 18.1683 4.16606L7.73674 9.38613Z",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M30.0008 21.5983V22.153C29.9226 23.8899 29.3827 25.4182 28.3795 26.7371C26.8356 28.767 24.7541 29.8546 22.1343 29.9999H21.6015C19.1582 29.8671 17.1697 28.8928 15.6376 27.077C14.6218 25.8737 14.0132 24.4744 13.8139 22.8789C13.1287 17.4088 18.0269 12.8364 23.4524 13.9045C27.1817 14.639 29.8226 17.826 30.0008 21.5983ZM28.7483 21.8749C28.7483 18.0792 25.6706 15.0023 21.8757 15.0023C18.0808 15.0023 15.0031 18.0799 15.0031 21.8749C15.0031 25.6698 18.0808 28.7475 21.8757 28.7475C25.6706 28.7475 28.7483 25.6698 28.7483 21.8749Z",
    fill: "black"
  })
], -1))
const _hoisted_16 = { class: "text-2xl font-semibold leading-tight" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center pb-1 lg:pb-4 bg-white dark:bg-gray-900\" data-v-0db161c8><div class=\"w-full\" data-v-0db161c8><label for=\"table-search\" class=\"sr-only\" data-v-0db161c8>Search</label><div class=\"relative mt-1\" data-v-0db161c8><div class=\"absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none\" data-v-0db161c8><svg class=\"w-4 h-4 text-gray-500 dark:text-gray-400\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" data-v-0db161c8><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z\" data-v-0db161c8></path></svg></div><input type=\"text\" id=\"table-search\" class=\"w-full block p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500\" placeholder=\"Search for items\" data-v-0db161c8></div></div></div>", 1)
const _hoisted_18 = { class: "flex justify-start lg:justify-end mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 mr-2",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 21"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44771 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8Z" })
], -1))
const _hoisted_20 = { class: "-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto" }
const _hoisted_21 = { class: "inline-block min-w-full shadow-md rounded-lg overflow-hidden" }
const _hoisted_22 = { class: "min-w-full leading-normal text-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-5 border-b-2 text-center text-xs font-semibold text-white uppercase tracking-wider" }, " #ID ", -1))
const _hoisted_24 = { class: "px-5 py-5 border-b-2 text-center text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_25 = { class: "px-5 py-5 border-b-2 text-center text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_26 = { class: "px-5 py-5 border-b-2 text-center text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_27 = { class: "px-5 py-5 border-b-2 text-center text-xs font-semibold text-white uppercase tracking-wider" }
const _hoisted_28 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_29 = { class: "text-gray-600 whitespace-no-wrap" }
const _hoisted_30 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_31 = { class: "text-gray-600 whitespace-no-wrap" }
const _hoisted_32 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_33 = { class: "text-gray-600 whitespace-no-wrap" }
const _hoisted_34 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_35 = { class: "text-gray-600 whitespace-no-wrap" }
const _hoisted_36 = { class: "w-fit m-auto" }
const _hoisted_37 = { class: "flex flex-row text-center items-center justify-items-center" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-0db161c8></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></g><g id=\"SVGRepo_iconCarrier\" data-v-0db161c8><path d=\"M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z\" stroke=\"#07d514\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13\" stroke=\"#07d514\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path></g>", 3)
const _hoisted_42 = [
  _hoisted_39
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-0db161c8></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></g><g id=\"SVGRepo_iconCarrier\" data-v-0db161c8><path d=\"M10 12V17\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M14 12V17\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M4 7H20\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path></g>", 3)
const _hoisted_47 = [
  _hoisted_44
]
const _hoisted_48 = {
  key: 2,
  class: "bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
}
const _hoisted_49 = {
  key: 0,
  class: "text-gray-700 text-2xl font-bold mb-5"
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "flex flex-wrap -mx-3 mb-6" }
const _hoisted_52 = { class: "w-full md:w-1/2 px-3 mb-6 md:mb-0" }
const _hoisted_53 = {
  class: "block text-left uppercase tracking-wide text-gray-700 text-xs font-bold mb-2",
  for: "grid-first-name"
}
const _hoisted_54 = { class: "w-full md:w-1/2 px-3" }
const _hoisted_55 = {
  class: "block uppercase tracking-wide text-left text-gray-700 text-xs font-bold mb-2",
  for: "grid-last-name"
}
const _hoisted_56 = { class: "flex flex-wrap -mx-3 mb-6" }
const _hoisted_57 = { class: "w-full px-3" }
const _hoisted_58 = {
  class: "block uppercase text-left tracking-wide text-gray-700 text-xs font-bold mb-2",
  for: "grid-model"
}
const _hoisted_59 = { class: "flex flex-wrap -mx-3 mb-6" }
const _hoisted_60 = { class: "w-full px-3" }
const _hoisted_61 = {
  class: "block uppercase text-left tracking-wide text-gray-700 text-xs font-bold mb-2",
  for: "grid-model"
}
const _hoisted_62 = { class: "flex items-center justify-center w-full mb-5" }
const _hoisted_63 = { class: "flex flex-col items-center justify-center pt-5 pb-6" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-8 h-8 mb-4 text-gray-500 dark:text-gray-400",
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
  })
], -1))
const _hoisted_65 = { class: "mb-2 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_66 = { class: "font-semibold" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "SVG, PNG, JPG or GIF (MAX. 800x400px)", -1))
const _hoisted_68 = {
  key: 2,
  class: "-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto"
}
const _hoisted_69 = { class: "inline-block min-w-full shadow-md rounded-lg overflow-hidden" }
const _hoisted_70 = { class: "min-w-full leading-normal" }
const _hoisted_71 = { class: "px-5 py-5 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" }
const _hoisted_72 = { class: "px-5 py-5 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" }
const _hoisted_73 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_74 = { class: "text-gray-600 whitespace-no-wrap" }
const _hoisted_75 = { class: "w-fit m-auto" }
const _hoisted_76 = { class: "flex flex-row text-center items-center justify-items-center" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = /*#__PURE__*/_createStaticVNode("<g id=\"SVGRepo_bgCarrier\" stroke-width=\"0\" data-v-0db161c8></g><g id=\"SVGRepo_tracerCarrier\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></g><g id=\"SVGRepo_iconCarrier\" data-v-0db161c8><path d=\"M10 12V17\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M14 12V17\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M4 7H20\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path> <path d=\"M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z\" stroke=\"#e60000\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0db161c8></path></g>", 3)
const _hoisted_81 = [
  _hoisted_78
]
const _hoisted_82 = { class: "flex items-center justify-between" }

import trackService from '../services/trackService'
import SidebarView from './partials/SidebarView.vue'
import HeaderView from './partials/HeaderView.vue'

import { ref , onMounted , Ref , PropType} from 'vue'
import { computed } from 'vue';

// const props = defineProps({
//   rawFiles: {
//     type: Array as PropType<File[]>,
//     required: true,
//   },
// })

export default /*#__PURE__*/_defineComponent({
  __name: 'TracksView',
  setup(__props) {

const tracks:any = ref([])
const rawFiles:any = ref([])
const showAddTrack = ref(false)
const infoTrack = ref({
  Identifier: ref(''),
  Mark: ref(''),
  Model: ref(''),
})
const isModalDelete = ref(false)
const showFormEditTrack = ref(false)
const showIdTrack = ref(null)
const showTrackEdit = ref({
  Identifier: ref(''),
  Mark: ref(''),
  Model: ref(''),
  id:ref(null)

})
const searchQuery = ref('')
const selectedFiles: Ref<File[]> = ref([]);

const showTypeRole = ref(0)

onMounted(() => {
    const item = localStorage.getItem('type');
    showTypeRole.value = Number(item)
})

const roleClass = computed(() => {
  if (showTypeRole.value === 3) {
    return 'asideBarSuperAdmin';
  } else if (showTypeRole.value === 2) {
    return 'asideBarAdmin';
  } else if (showTypeRole.value === 1) {
    return 'asideBarDriver';
  }  else if (showTypeRole.value === 4) {
    return 'asideBarSuperSuperAdmin';
  } 
  else {
    return '';
  }
});


const deleteFile = (itemName: string) => {
  const index = selectedFiles.value.findIndex((item) => item.name === itemName);
  if (index !== -1) {
    selectedFiles.value.splice(index, 1);
  }
};

function onDrop(event: DragEvent) {
  event.preventDefault()
  let isValid = true;
  const allowedExtensions = /(\.rsf|\.png)$/i;
  const files : any = event.dataTransfer?.files;

  for(const file of files){
    if(!allowedExtensions.exec(file.name)){
      isValid = false
    }
  }
  if (isValid) {
    const files = event.dataTransfer?.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!selectedFiles.value.some(existingFile => existingFile.name === file.name)) {
            selectedFiles.value.push(file);
          }
      }
    }
    // alert('bgha idkhal l save')
    // handleInputFiles(event)
    // saveFiles(e.dataTransfer.files)

  } else {
    alert('Please import valid run files')
    // toast.warning(`Please import valid run files`, {
    //     position: 'top-right',
    //     dismissible: false,
    //     queue: true,
    // })
    // e.currentTarget.classList.remove('bg-gray-300')
    // e.currentTarget.classList.add('border-2 border-dashed border-[#F5F5F5]')
  }
  // importText.value = '<span class="text-primary text-base">Drag or click here</span> to add files'
}

const handleInputFiles = (event: Event) => {

  const input = event.target as HTMLInputElement;
  if (input.files) {
    for (let i = 0; i < input.files.length; i++) {
      const file = input.files[i];
      if (!selectedFiles.value.some(existingFile => existingFile.name === file.name)) {
            selectedFiles.value.push(file);
          }
    }
  }
  // saveFiles(event.target.files)
}

function dragover(event: any) {
  event.preventDefault()
  if (!event.currentTarget.classList.contains('bg-gray-300')) {
    event.currentTarget.classList.remove('bg-gray-100')
    event.currentTarget.classList.add('bg-gray-300')
    // importText.value = '<span class="text-primary text-base">Drop here</span> to add files'
  }
}

function dragleave(event: any) {
  event.currentTarget.classList.add('bg-gray-100')
  event.currentTarget.classList.remove('bg-gray-300')
  // importText.value = '<span class="text-primary text-base">Drag or click here</span> to add files'
}
const saveFiles = (files: any[]) => {
   console.log('sasa')
}
const saveNewTrack = () => {
  showFormEditTrack.value = false
  trackService.getTracks()
  .then(( response: any ) => {
    tracks.value = response.data
  })
  .catch((error:any) => {
    console.log(error)
  });
}

const showFormTrack = () => {
    showAddTrack.value = true
}
const addTrack = () => {
    trackService.addTrack(infoTrack.value)
    .then(( response: any ) => {
      saveNewTrack()
      showAddTrack.value = false
    })
    .catch((error:any) => {
      console.log(error)
    });
}

const returnToGridTrack = () => {
  showAddTrack.value = false
  showFormEditTrack.value = false
}
const showEditTrack  = (item : any) => {
  showIdTrack.value = item
  showAddTrack.value = true
  showFormEditTrack.value = true
  trackService.showEditTrackById(showIdTrack.value)
    .then(( response: any ) => {
      showTrackEdit.value.Identifier = response.data.identifier
      showTrackEdit.value.Mark = response.data.mark
      showTrackEdit.value.Model = response.data.model
    })
    .catch((error:any) => {
      console.log(error)
    });
}
const editTrackById = () => {
  console.log(showIdTrack.value)
  showTrackEdit.value.id = showIdTrack.value
  trackService.editTrack(showIdTrack.value,showTrackEdit.value)
    .then(( response: any ) => {
      console.log('response')
      console.log(response.data)
    })
    .catch((error:any) => {
      console.log(error)
    });
}
const confirmDelete  = (item : any) => {
  isModalDelete.value = true
  showIdTrack.value = item;
}
const deleteItem = (item : any) => {
  trackService.deleteTrackById(showIdTrack.value)
    .then(( response: any ) => {
      saveNewTrack()
      showAddTrack.value = false
    })
    .catch((error:any) => {
      console.log(error)
    });
    showIdTrack.value = null
    isModalDelete.value = false

}
const cancelDelete = () =>{
  isModalDelete.value = false
  showIdTrack.value = null;
}
onMounted(() => {
  saveNewTrack()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarView),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderView),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          (isModalDelete.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: cancelDelete,
                    class: "text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white",
                    "data-modal-toggle": "deleteModal"
                  }, [
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('Closemodal')), 1)
                  ]),
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('AreYouSureYouWantToDeleteThisTrack')), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      onClick: cancelDelete,
                      class: "py-2 px-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-200 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                    }, _toDisplayString(_ctx.$t('NoCancel')), 1),
                    _createElementVNode("button", {
                      onClick: deleteItem,
                      class: "py-2 px-3 text-sm font-medium text-center text-white bg-red-600 rounded-lg hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-500 dark:hover:bg-red-600 dark:focus:ring-red-900"
                    }, _toDisplayString(_ctx.$t('YesSure')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!showAddTrack.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("h2", _hoisted_16, _toDisplayString(_ctx.$t('Tracks')), 1)
                  ]),
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("button", {
                      onClick: showFormTrack,
                      class: _normalizeClass([roleClass.value, "text-white focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-base font-bold p-1 text-center inline-flex items-center px-2 py-2 lg:py-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"])
                    }, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Add Track')), 1)
                    ], 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("table", _hoisted_22, [
                      _createElementVNode("thead", {
                        class: _normalizeClass(roleClass.value)
                      }, [
                        _createElementVNode("tr", null, [
                          _hoisted_23,
                          _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('Identifier')), 1),
                          _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('Mark')), 1),
                          _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('Model')), 1),
                          _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('ACTION')), 1)
                        ])
                      ], 2),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tracks.value, (track, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_28, [
                              _createElementVNode("p", _hoisted_29, _toDisplayString(track.id), 1)
                            ]),
                            _createElementVNode("td", _hoisted_30, [
                              _createElementVNode("p", _hoisted_31, _toDisplayString(track.identifier), 1)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("p", _hoisted_33, _toDisplayString(track.mark), 1)
                            ]),
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("p", _hoisted_35, _toDisplayString(track.model), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  (_openBlock(), _createElementBlock("svg", {
                                    onClick: ($event: any) => (showEditTrack(track.id)),
                                    class: "cursor-pointer",
                                    width: "25px",
                                    height: "25px",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, _hoisted_42, 8, _hoisted_38)),
                                  (_openBlock(), _createElementBlock("svg", {
                                    onClick: ($event: any) => (confirmDelete(track.id)),
                                    class: "cursor-pointer",
                                    width: "30px",
                                    height: "30px",
                                    viewBox: "0 0 24.00 24.00",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    stroke: "#e60000"
                                  }, _hoisted_47, 8, _hoisted_43))
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (showAddTrack.value)
            ? (_openBlock(), _createElementBlock("form", _hoisted_48, [
                (!showFormEditTrack.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_49, _toDisplayString(_ctx.$t('AddnewTrack')), 1))
                  : (_openBlock(), _createElementBlock("h3", _hoisted_50, _toDisplayString(_ctx.$t('EditTrack')), 1)),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('Identifier')), 1),
                    (!showFormEditTrack.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((infoTrack.value.Identifier) = $event)),
                          class: "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white",
                          id: "grid-first-name",
                          type: "text"
                        }, null, 512)), [
                          [_vModelText, infoTrack.value.Identifier]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showTrackEdit.value.Identifier) = $event)),
                          class: "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white",
                          id: "grid-first-name",
                          type: "text"
                        }, null, 512)), [
                          [_vModelText, showTrackEdit.value.Identifier]
                        ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('Mark')), 1),
                    (!showFormEditTrack.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((infoTrack.value.Mark) = $event)),
                          class: "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                          id: "grid-last-name",
                          type: "text"
                        }, null, 512)), [
                          [_vModelText, infoTrack.value.Mark]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showTrackEdit.value.Mark) = $event)),
                          class: "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                          id: "grid-last-name",
                          type: "text"
                        }, null, 512)), [
                          [_vModelText, showTrackEdit.value.Mark]
                        ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('Model')), 1),
                    (!showFormEditTrack.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((infoTrack.value.Model) = $event)),
                          class: "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                          id: "grid-model",
                          type: "text"
                        }, null, 512)), [
                          [_vModelText, infoTrack.value.Model]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showTrackEdit.value.Model) = $event)),
                          class: "appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500",
                          id: "grid-model",
                          type: "text"
                        }, null, 512)), [
                          [_vModelText, showTrackEdit.value.Model]
                        ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('ListDocs')), 1),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("label", {
                        onDrop: onDrop,
                        onDragover: dragover,
                        onDragleave: dragleave,
                        for: "dropzone-file",
                        class: "flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                      }, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createElementVNode("p", _hoisted_65, [
                            _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.$t('Clicktoupload')), 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('ordraganddrop')), 1)
                          ]),
                          _hoisted_67
                        ]),
                        _createElementVNode("input", {
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (handleInputFiles($event))),
                          id: "dropzone-file",
                          type: "file",
                          class: "hidden",
                          multiple: ""
                        }, null, 32)
                      ], 32)
                    ])
                  ])
                ]),
                (selectedFiles.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("table", _hoisted_70, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.$t('FilesName')), 1),
                              _createElementVNode("th", _hoisted_72, _toDisplayString(_ctx.$t('ACTION')), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFiles.value, (file, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_73, [
                                  _createElementVNode("p", _hoisted_74, _toDisplayString(file.name), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        onClick: ($event: any) => (deleteFile(file.name)),
                                        class: "cursor-pointer",
                                        width: "30px",
                                        height: "30px",
                                        viewBox: "0 0 24.00 24.00",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        stroke: "#e60000"
                                      }, _hoisted_81, 8, _hoisted_77))
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_82, [
                  (!showFormEditTrack.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: addTrack,
                        class: _normalizeClass([roleClass.value, "text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"]),
                        type: "button"
                      }, _toDisplayString(_ctx.$t('Save')), 3))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: editTrackById,
                        class: "bg-green-700 hover:bg-green-800 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline",
                        type: "button"
                      }, _toDisplayString(_ctx.$t('Edit')), 1)),
                  _createElementVNode("a", {
                    onClick: returnToGridTrack,
                    class: "inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800",
                    href: "#"
                  }, _toDisplayString(_ctx.$t('Return')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})